import script from "./ConsultDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultDetail.vue?vue&type=script&setup=true&lang=js"

import "./ConsultDetail.vue?vue&type=style&index=0&id=99045df0&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99045df0"]])

export default __exports__